// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IPsService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };
  
  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getIPs(): Observable<void> { // No se utiliza por eso no se pone modelo, header o query
    return this.http.get<void>(`${this.globalService.apiUrl.url}/Ips`, this.httpOptions);
  }

  postCreateIpKey(key: string): Observable<void> {
    let params: HttpParams = new HttpParams();
    params = params.set('key', key);

    return this.http.post<void>(`${this.globalService.apiUrl.url}/Ips`, [], { ...this.httpOptions, params });
  }

  deleteIP(key: string, ips: string[]): Observable<void> {
    const options: { headers: HttpHeaders, params: HttpParams, body: string[] } = { ...this.httpOptions, body: ips };
    let params: HttpParams = new HttpParams();
    params = params.set('key', key);

    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Ips`, { ...options, params });
  }

  getIpKeys(): Observable<string[]> {
    return this.http.get<string[]>(`${this.globalService.apiUrl.url}/Ips/Keys`, this.httpOptions);
  }

  getIPsAll(): Observable<void> { // No se utiliza por eso no se pone modelo, header o query
    return this.http.get<void>(`${this.globalService.apiUrl.url}/Ips/all`, this.httpOptions);
  }

  getKeysFromIP(ip: string): Observable<string[]> {
    let params: HttpParams = new HttpParams();
    params = params.set('ip', ip);

    return this.http.get<string[]>(`${this.globalService.apiUrl.url}/Ips/get-keys-from-ip`, this.httpOptions);
  }

  postAddIPToKey(key: string, ip: string): Observable<void> {
    let params: HttpParams = new HttpParams();
    params = params.set('ip', ip);

    return this.http.post<void>(`${this.globalService.apiUrl.url}/Ips/${key}`, null, { ...this.httpOptions, params });
  }

  getIPsFromKey(key: string, expand: boolean): Observable<string[]> {
    let params: HttpParams = new HttpParams();
    params = params.set('expandir', expand);

    return this.http.get<string[]>(`${this.globalService.apiUrl.url}/Ips/${key}`, { ...this.httpOptions, params });
  }

  putIPToKey(key: string): Observable<void> { // No se utiliza por eso no se pone modelo, header o query
    return this.http.put<void>(`${this.globalService.apiUrl.url}/Ips/${key}`, null, this.httpOptions);
  }

  deleteIpKey(key: string): Observable<void> {
    let params: HttpParams = new HttpParams();
    params = params.set('forzar', true);

    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Ips/${key}`, { ...this.httpOptions, params });
  }

  postRenameIpKey(key: string, newKey: string): Observable<void> {
    let params: HttpParams = new HttpParams();
    params = params.set('newKey', newKey);

    return this.http.post<void>(`${this.globalService.apiUrl.url}/Ips/${key}/Rename`, null,{ ...this.httpOptions, params });
  }
}